import React, { useContext } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../contexts/auth/authContext';

const Styled403 = styled.div`
    text-align: center;

    height: 100vh;

    img {
        height: 70vh;
    }
`;

const AccessForbidden: React.FunctionComponent = () => {
    // To navigate to other page
    const history = useHistory();
    const authContext = useContext(AuthContext);
    const { closeSession } = authContext;

    const outAndHome = () => {
        closeSession();
        history.push('/');
    };

    return (
        <div>
            <Styled403>
                <img alt="unauthorized access" src="/assets/images/emergency.png" />
                <h1>Sorry, the access to this page is forbidden</h1>
                <p>If you need access, please contact our staff</p>
                <button type="button" onClick={outAndHome} className="btn btn-primary">
                    Back to home page
                </button>
            </Styled403>
        </div>
    );
};

export default AccessForbidden;
